module.exports = __webpack_public_path__ + "img/finish.4459174d.png";